import React from 'react';

import { Tooltip as PrismUITooltip } from '@nutanix-ui/prism-reactjs';
import type { ToolTipProps as PrismUITooltipProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Tooltip/Tooltip';
import { TooltipAppearance } from '@nutanix-ui/prism-reactjs/lib/components/v2/Tooltip/Tooltip';
import type { TooltipContentProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Tooltip/TooltipContent';

export { TooltipAppearance, TooltipContentProps };

export type TooltipProps = Omit<PrismUITooltipProps, 'oldTooltip'> & {
  disabled?: boolean;
};

export default function Tooltip({ disabled, ...props }: React.PropsWithChildren<TooltipProps>) {
  if (disabled || !props.content) {
    return React.isValidElement(props.children) ? props.children : null;
  }
  return <PrismUITooltip oldTooltip={false} restoreFocus={true} {...props} />;
}
